module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "indent3"
  }, [_c('p', {
    staticClass: "left sink"
  }, [_vm._v("Is the Pacifique Sea my home?")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_vm._v("—J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONNE,")]), _c('br'), _vm._v("\n“Hymne to God my God”")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("Stolto! a cui parlo? Misero! Che tento?")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("Racconto il dolor mio")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("a l’insensata riva")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("a la mutola selce, al sordo vento . . .")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("Ahi, ch’altro non risponde")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("che il mormorar del’onde!")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_vm._v("—G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IOVAN")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATTISTA")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARINO,")]), _c('br'), _vm._v("\n“Eco,” "), _c('em', [_vm._v("La Lira,")]), _vm._v(" xix")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0231ff64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0